import { useState } from "react";
import Box from "@mui/material/Box";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp } from "../../lib/redux";
import { getNameBusinessTheme } from "../../actions/getters";
import Button from "../Buttons/Button";

const ContainerModalActions = ({
  propsPrimaryButton = {},
  propsSecondaryButton = {},
  propsTertiaryButton = {},
  hasPadding = true,
  sx = {},
}) => {
  const [isLoadingPrimaryButton, setIsLoadingPrimaryButton] = useState(false);
  const [isLoadingSecondaryButton, setIsLoadingSecondaryButton] =
    useState(false);
  const [isLoadingTertiaryButton, setIsLoadingTertiaryButton] = useState(false);

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const NAME_BUSINESS = dispatch(getNameBusinessTheme());

  const buttonsCount = [
    propsSecondaryButton?.showButton,
    propsTertiaryButton?.showButton,
    propsPrimaryButton?.showButton,
  ].filter(Boolean).length;

  const hasOneButton = buttonsCount === 1;

  const sxButtonOneButton = {
    width: "auto",
  };
  const sxButtonTwoButtons = {
    width: "100%",
  };

  const sxContainerOneButton = {
    justifyContent: "center",
  };
  const sxContainerTwoButtons = {
    justifyContent: "center",
  };

  const sxContainer = hasOneButton
    ? sxContainerOneButton
    : sxContainerTwoButtons;

  const sxButton = hasOneButton ? sxButtonOneButton : sxButtonTwoButtons;

  const sxPadding = hasPadding
    ? {
        px: {
          xs: 3,
          sm: 5,
        },
        pb: 2,
      }
    : {};

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        gap: 1,
        ...sxPadding,
        ...sxContainer,
        ...sx,
      }}
    >
      {propsSecondaryButton?.showButton && (
        <Button
          color="secondary"
          {...propsSecondaryButton}
          loading={isLoadingSecondaryButton || propsSecondaryButton?.loading}
          onClick={async () => {
            setIsLoadingSecondaryButton(true);
            await propsSecondaryButton?.onClick();
            setIsLoadingSecondaryButton(false);
          }}
          sx={{
            ...propsSecondaryButton?.sx,
            width: "100%",
            ...sxButton,
          }}
        >
          {t(propsSecondaryButton?.text, {
            NAME_BUSINESS,
          })}
        </Button>
      )}
      {propsTertiaryButton?.showButton && (
        <Button
          color="secondary"
          {...propsTertiaryButton}
          loading={isLoadingTertiaryButton || propsTertiaryButton?.loading}
          onClick={async () => {
            setIsLoadingTertiaryButton(true);
            await propsTertiaryButton?.onClick();
            setIsLoadingTertiaryButton(false);
          }}
          sx={{
            ...propsTertiaryButton?.sx,
            width: "100%",
            ...sxButton,
          }}
        >
          {t(propsTertiaryButton?.text, {
            NAME_BUSINESS,
          })}
        </Button>
      )}
      {propsPrimaryButton?.showButton && (
        <Button
          color="primary"
          {...propsPrimaryButton}
          loading={isLoadingPrimaryButton || propsPrimaryButton?.loading}
          onClick={async (e) => {
            setIsLoadingPrimaryButton(true);
            await propsPrimaryButton?.onClick(e);
            setIsLoadingPrimaryButton(false);
          }}
          sx={{
            ...propsPrimaryButton?.sx,
            width: "100%",
            minWidth: 130,
            ...sxButton,
          }}
        >
          {t(propsPrimaryButton?.text, {
            NAME_BUSINESS,
          })}
        </Button>
      )}
    </Box>
  );
};

export default ContainerModalActions;
